import province from '../utils/province.js';

export const businessFormFields = [
  {
    name: 'name',
    label: 'Ragione Sociale',
    type: 'text',
    required: true,
    gridSpan: 12,
  },
  {
    name: 'contactPerson',
    label: 'Persona di Riferimento',
    type: 'text',
    required: true,
    gridSpan: 12,
  },
  {
    name: 'email',
    label: 'Email Aziendale',
    type: 'email',
    required: true,
    gridSpan: 6,
  },
  {
    name: 'phone',
    label: 'Telefono',
    type: 'tel',
    required: true,
    gridSpan: 6,
  },
  {
    name: 'address',
    label: 'Indirizzo Sede Legale',
    type: 'text',
    required: true,
    gridSpan: 6,
  },
  {
    name: 'city',
    label: 'Citta',
    type: 'text',
    required: true,
    gridSpan: 3,
  },
  {
    name: 'province',
    label: 'Provincia',
    type: 'select',
    required: true,
    gridSpan: 3,
    options: province.map(p => ({ value: p.sigla, label: p.nome })),
  },
  {
    name: 'sector',
    label: 'Settore',
    type: 'text',
    required: true,
    gridSpan: 12,
  },
  {
    name: 'description',
    label: 'Descrizione Attività',
    type: 'textarea',
    required: true,
    gridSpan: 12,
    helperText: 'Una breve descrizione dell\'azienda e di cosa si occupa.'
  },
{
  name: 'categories',
  label: 'Aree di competenza',
  type: 'autocomplete',
  required: false,
  gridSpan: 12,
}
];